/* SEW Assistant - on-site chat widget.
   Answers come from the store's published policies and checkout shipping rates.
   Product, cart and collection data come from Shopify's own public endpoints. */
(function () {
  'use strict';

  var CFG = {
    bot: 'SEW Assistant',
    tagline: 'Premium metal home essentials',
    wa: '923205627529',
    openHour: 10,
    closeHour: 20,
    tzOffset: 5,
    cur: 'Rs.',
    freeOver: 3000
  };

  var KB = [
    { id: 'greeting',
      k: ['hi','hello','hey','salam','assalam','assalamualaikum','aoa','salaam','hy','helo','hlo','good morning','good afternoon','good evening','kaise ho','kya haal','kesy ho','kaisay ho'],
      en: 'Welcome to SEW Markaz. I am the SEW Assistant.\n\nI can help you find products, check delivery and payment details, or track an order.',
      ur: 'SEW Markaz mein khush aamdeed. Main SEW Assistant hoon.\n\nProducts dhoondhne, delivery aur payment ki tafseel, ya order tracking mein aap ki madad kar sakta hoon.',
      ce: ['Browse products','Delivery charges','Track my order','Return policy'],
      cu: ['Products dekhne hain','Delivery charges','Order track karna hai','Return policy'] },

    { id: 'shipping',
      k: ['shipping','delivery charges','delivery charge','courier charge','shipping cost','kitni shipping','delivery kitni','charges','shipping charges','postage','freight','delivery fee','kharcha','shipping rate','free delivery','free shipping'],
      en: 'Delivery charges:\n\u2022 Karachi: Rs. 200, and free on orders of Rs. 3,000 or more\n\u2022 Other cities: Rs. 350\n\nThe exact charge is shown at checkout before you confirm.',
      ur: 'Delivery charges:\n\u2022 Karachi: Rs. 200, aur Rs. 3,000 ya us se upar ke order par free\n\u2022 Doosre shehron mein: Rs. 350\n\nCheckout par confirm karne se pehle asal charge dikh jata hai.',
      ce: ['Delivery time','Is COD available?','Browse products'],
      cu: ['Delivery mein kitne din?','COD available hai?','Products dekhne hain'] },

    { id: 'delivery_time',
      k: ['kitne din','kab aayega','delivery time','how long','how many days','kitna time','kab milega','kab tak','delivery days','dispatch','arrive','pohanchega','pohnchega','delivery kab','time lagega','lead time'],
      en: 'Delivery within Karachi takes 5 to 6 working days.\n\nOrders placed on a weekend or public holiday are processed the next working day. For other cities our team confirms the timeline when the order is placed.\n\nTracking details are sent on WhatsApp once your order is dispatched.',
      ur: 'Karachi ke andar delivery mein 5 se 6 working days lagte hain.\n\nWeekend ya chutti ke din ke orders agle working day process hote hain. Doosre shehron ke liye team order ke waqt timeline confirm kar deti hai.\n\nOrder dispatch hote hi tracking details WhatsApp par bhej di jati hain.',
      ce: ['Delivery charges','Track my order'],
      cu: ['Delivery charges kitne hain?','Order track karna hai'] },

    { id: 'cod',
      k: ['cod','cash on delivery','cash','advance','payment on delivery','ghar pe payment','delivery pe paise','cash pe'],
      en: 'Yes, Cash on Delivery is available.\n\nHow it works:\n\u2022 Our team calls to confirm the order first, so please use a number you answer\n\u2022 The courier calls again before delivery\n\u2022 You pay the courier at your door, including the delivery charge\n\u2022 The courier tries twice; if both attempts fail the parcel comes back to us\n\nA complete address with a landmark makes a big difference to getting it right the first time.',
      ur: 'Ji haan, Cash on Delivery available hai.\n\nTareeqa ye hai:\n\u2022 Pehle hamari team order confirm karne ke liye call karti hai, is liye aisa number dein jo aap uthate hon\n\u2022 Delivery se pehle courier dobara call karta hai\n\u2022 Aap darwaze par courier ko payment karte hain, jis mein delivery charge shamil hai\n\u2022 Courier do martaba koshish karta hai; dono baar na ho to parcel wapas aa jata hai\n\nMukammal address aur qareebi nishani likhne se pehli hi baar delivery ho jati hai.',
      ce: ['Delivery time','Failed delivery','Browse products'],
      cu: ['Delivery mein kitne din?','Delivery na ho to?','Products dekhne hain'] },

    { id: 'payment',
      k: ['payment','payment method','easypaisa','jazzcash','card','paise kaise','kaise pay','online payment','debit','credit','visa','mastercard','checkout'],
      en: 'We accept:\n\u2022 Cash on Delivery\n\u2022 JazzCash\n\u2022 EasyPaisa\n\u2022 Visa and Mastercard',
      ur: 'Hum ye payment methods accept karte hain:\n\u2022 Cash on Delivery\n\u2022 JazzCash\n\u2022 EasyPaisa\n\u2022 Visa aur Mastercard',
      ce: ['How does COD work?','Browse products'],
      cu: ['COD kaise kaam karta hai?','Products dekhne hain'] },

    { id: 'return',
      k: ['return','wapis','refund','exchange','badalna','change karna','replace','return policy','paise wapis','return kaise'],
      en: 'Returns are accepted within 7 days of delivery.\n\nThe item must be unused, in its original packaging, and you will need your order ID. Used or installed items, sale items, and custom orders cannot be returned unless they are defective.\n\nExchanges for a different variant are also possible within 7 days, subject to stock.',
      ur: 'Delivery ke 7 din ke andar return liya ja sakta hai.\n\nProduct istemal na hua ho, original packing mein ho, aur order ID chahiye hogi. Istemal shuda ya install kiye gaye items, sale items, aur custom orders return nahi hote, illa ye ke wo defective hon.\n\n7 din ke andar doosre variant se exchange bhi ho sakta hai, agar stock mojood ho.',
      ce: ['Damaged item','How do refunds work?'],
      cu: ['Damaged item mila hai','Refund kaise milta hai?'] },

    { id: 'damaged',
      k: ['damage','damaged','toota','broken','faulty','defective','galat product','wrong item','kharab mila','tuta hua'],
      en: 'If an item arrives defective, damaged or incorrect, please contact us within 48 hours of delivery with photos and your order ID.\n\nWe will arrange a replacement or a full refund at no extra cost, and we cover the return shipping in that case.',
      ur: 'Agar product defective, damaged ya ghalat mile to delivery ke 48 ghante ke andar photos aur order ID ke sath rabta karein.\n\nHum bila kisi izafi charge ke replacement ya poora refund kar dete hain, aur us soorat mein return shipping bhi hum bardasht karte hain.',
      ce: ['Talk to the team'],
      cu: ['Team se baat karni hai'],
      lead: true },

    { id: 'refund_process',
      k: ['refund kaise','refund process','paise kab','refund time','kitne din mein refund','refund method','refund kab milega'],
      en: 'Once we receive the returned item, the refund is processed within 5 to 7 working days.\n\nFor COD orders the refund is sent via JazzCash or EasyPaisa. For online payments it is sent by bank transfer.\n\nIf the return is not due to our error, the return shipping cost is borne by the customer.',
      ur: 'Wapas kiya gaya product mil jane ke baad refund 5 se 7 working days mein process ho jata hai.\n\nCOD orders ka refund JazzCash ya EasyPaisa par bheja jata hai. Online payment ka refund bank transfer se.\n\nAgar return hamari ghalti ki wajah se nahi hai to return shipping ka kharcha customer par hota hai.',
      ce: ['Return policy','Talk to the team'],
      cu: ['Return policy','Team se baat karni hai'] },

    { id: 'failed_delivery',
      k: ['delivery na ho','failed delivery','ghar pe nahi tha','miss ho gaya','courier nahi aaya','redelivery','dobara delivery','delivery attempt','wapas chala gaya'],
      en: 'Our courier attempts delivery up to two times.\n\nIf both attempts fail, the order is returned to us and an additional delivery charge may apply if you would like it sent again.\n\nPlease also make sure your address is complete and correct when ordering, as we cannot cover delays caused by an incorrect address.',
      ur: 'Hamara courier delivery ki do martaba koshish karta hai.\n\nAgar dono martaba delivery na ho sake to order wapas aa jata hai, aur dobara bhejne par izafi delivery charge lag sakta hai.\n\nOrder karte waqt apna address mukammal aur durust likhein, kyunke ghalat address ki wajah se hone wali taakheer ki zimmedari hum nahi le sakte.',
      ce: ['Track my order','Talk to the team'],
      cu: ['Order track karna hai','Team se baat karni hai'] },

    { id: 'cancel',
      k: ['cancel','cancellation','order cancel','cancel karna','mana karna','order rok'],
      en: 'An order can be cancelled any time before it is dispatched. Send us a message on WhatsApp with your order ID and we will take care of it.\n\nOnce the order has been dispatched it cannot be cancelled.',
      ur: 'Order dispatch hone se pehle kabhi bhi cancel kiya ja sakta hai. WhatsApp par apni order ID ke sath message kar dein, hum kar denge.\n\nDispatch hone ke baad order cancel nahi ho sakta.',
      ce: ['Talk to the team'],
      cu: ['Team se baat karni hai'],
      lead: true },

    { id: 'care',
      k: ['care','saaf','clean','cleaning','maintain','dhona','wash','polish','care instructions','kaise saaf','safai','maintenance'],
      en: 'General care for metal home pieces:\n\u2022 Wipe with a soft, dry cloth\n\u2022 Avoid harsh chemicals and steel scrubs\n\u2022 Dry bathroom fittings from time to time\n\u2022 Keep wall pieces away from direct water\n\nFor care specific to a product, our team can advise you.',
      ur: 'Metal home items ki aam dekhbhal:\n\u2022 Naram, khushk kapre se saaf karein\n\u2022 Tez chemicals aur steel scrub se parhez karein\n\u2022 Bathroom fittings ko waqfe waqfe se khushk karein\n\u2022 Wall pieces ko direct paani se door rakhein\n\nKisi khaas product ke liye team aap ko rehnumai de sakti hai.',
      ce: ['Browse products','Talk to the team'],
      cu: ['Products dekhne hain','Team se baat karni hai'] },

    { id: 'bulk', lead: true,
      k: ['bulk','wholesale','b2b','thok','corporate','dealer','distributor','reseller','bohat saare','zyada quantity','bulk order','wholesale rate','trade price','bulk pricing','corporate gift'],
      en: 'For bulk and corporate orders our team prepares a quotation based on the products and quantity you need.\n\nShare the details and I will connect you with them.',
      ur: 'Bulk aur corporate orders ke liye hamari team products aur quantity ke hisab se quotation tayar karti hai.\n\nTafseel bata dein, main aap ko un se connect kar deta hoon.',
      ce: [], cu: [] },

    { id: 'custom', lead: true,
      k: ['customize','apni marzi','banwana','made to order','special order','custom size','apna design','naam likhwana','engraving','personalize','customized'],
      en: 'For custom sizes or designs, our team will need to look at what you have in mind before confirming whether it is possible and what it would cost.\n\nShare the details and I will pass you on to them.',
      ur: 'Custom size ya design ke liye hamari team ko pehle dekhna hoga ke wo mumkin hai ya nahi aur kya kharcha aayega.\n\nTafseel bata dein, main aap ko un tak pohancha deta hoon.',
      ce: [], cu: [] },

    { id: 'contact', lead: true,
      k: ['contact','phone number','call karna','baat karni','talk to human','talk to team','speak to','human','agent','representative','customer service','helpline','rabta','staff','banda','koi insan','team se','support','email'],
      en: 'You can reach our team directly:\n\nWhatsApp and phone: +92 320 5627529\nEmail: info@sewmarkaz.com\nMonday to Saturday, 10 AM to 8 PM',
      ur: 'Aap hamari team se seedha rabta kar sakte hain:\n\nWhatsApp aur phone: +92 320 5627529\nEmail: info@sewmarkaz.com\nSomwar se Hafta, 10 AM se 8 PM',
      ce: [], cu: [] },

    { id: 'hours',
      k: ['timing','kab khula','working hours','kitne baje','close','band','kab tak khule','office time','opening hours','sunday'],
      en: 'Our team is available Monday to Saturday, 10 AM to 8 PM. We are closed on Sunday.\n\nThe website takes orders around the clock, and anything placed outside these hours is confirmed on the next working day.',
      ur: 'Hamari team Somwar se Hafta, 10 AM se 8 PM tak available hoti hai. Itwar ko band rehte hain.\n\nWebsite par order 24 ghante liye jate hain, aur in auqat ke bahar ka order agle working day confirm hota hai.',
      ce: ['Browse products','Delivery charges'],
      cu: ['Products dekhne hain','Delivery charges'] },

    { id: 'location',
      k: ['location','address','showroom','kahan hain','physical store','outlet','dukan','office kahan'],
      en: 'We are based in Karachi and orders are taken online.\n\nFor anything that needs a visit, please message us on WhatsApp first.',
      ur: 'Hum Karachi mein hain aur orders online liye jate hain.\n\nAgar milna ho to pehle WhatsApp par message kar lein.',
      ce: ['Talk to the team','Delivery charges'],
      cu: ['Team se baat karni hai','Delivery charges'] },

    { id: 'discount',
      k: ['discount','sale','offer','promo','coupon','coupon code','sasta','kam price','cheap','rebate','bargain','last price','final price','promo code'],
      en: 'Free delivery applies within Karachi on orders of Rs. 3,000 or more.\n\nAny running promotions are shown on the website, and seasonal sales are announced on our Instagram first.',
      ur: 'Karachi ke andar Rs. 3,000 ya us se upar ke order par delivery free hai.\n\nJo bhi promotion chal raha ho wo website par nazar aata hai, aur seasonal sales ka elan sab se pehle hamare Instagram par hota hai.',
      ce: ['Browse products','Delivery charges'],
      cu: ['Products dekhne hain','Delivery charges'] },

    { id: 'stock',
      k: ['out of stock','restock','kab aayega stock','in stock','stock mein'],
      en: 'Anything showing an Add to Cart button on the website is in stock.\n\nTell me the product name and I will check it for you.',
      ur: 'Website par jis product par Add to Cart ka button hai, wo stock mein hai.\n\nProduct ka naam bata dein, main check kar deta hoon.',
      ce: ['Browse products'], cu: ['Products dekhne hain'] },

    { id: 'thanks',
      k: ['thanks','thank you','shukriya','jazakallah','thnx','mehrbani','bohat shukriya','appreciate'],
      en: 'Glad to help. Let me know if there is anything else.',
      ur: 'Madad kar ke khushi hui. Kisi aur cheez ki zaroorat ho to bata dijiye.',
      ce: ['Browse products','Delivery charges'],
      cu: ['Products dekhne hain','Delivery charges'] },

    { id: 'bye',
      k: ['bye','khuda hafiz','allah hafiz','goodbye','see you','chalta hoon'],
      en: 'Thank you for visiting SEW Markaz. We hope to serve you soon.',
      ur: 'SEW Markaz tashreef lane ka shukriya. Umeed hai jald aap ki khidmat ka mauqa milega.',
      ce: [], cu: [] }
  ];

  var UR = ['hai','hain','kya','kia','kaise','kaisay','kitna','kitni','kitne','mujhe','muje','aap','ap','ka','ki','ke','ko','se','me','mein','nahi','nai','chahiye','chahye','kar','karna','karni','karo','bhej','bhejo','kab','tak','dikhao','dikhaen','batao','bata','acha','theek','thik','han','haan','wala','wali','wale','koi','sab','bhi','par','pe','yeh','ye','woh','hum','main','mai','apna','apni','lena','dena','milega','milegi','hoga','hogi','raha','rahi','kuch','zyada','sasta','mehnga','paise','rupay'];
  var EN = ['the','is','are','what','how','can','do','does','you','your','my','me','have','want','need','please','tell','show','give','send','when','where','which','and','for','with','this','that','about','would','could','there','their','from','any','some','something','anything'];

  var PT = ['product','products','dikhao','dikhaen','show','item','items','cheez','saman','catalog','collection','buy','kharidna','price','qeemat','keemat','kimat','rate','cost',
            'wall art','wall','bathroom','kitchen','car hanging','hanging','tissue','soap','towel','clock','spice','decor','decoration','gift','set','holder','rack','dispenser','shelf','stand','organizer','hook','mirror','basket','tray'];

  var FILLER = ['product','products','item','items','cheez','saman','catalog','collection','buy','kharidna','show','dikhao','dikhaen','batao','price','qeemat','keemat','kimat','rate','cost','under','below','above','over','budget','within','andar','niche','neeche','upar','max','maximum','min','minimum','rupees','rupee','rs','pkr'];

  /* Ways a customer refers to the product they are already looking at. */
  var THIS_PHRASES = ['this product','this item','this one','this piece','ye product','yeh product','ye wala','yeh wala','is product','iska','iski','is ka','is ki','isi ka','isi ki'];
  var ABOUT_WORDS = ['available','stock','price','cost','size','color','colour','material','kitne','kitna','kitni','qeemat','keemat','dimension','weight'];

  var S = { open: false, lang: 'en', msgs: [], fails: 0, leadAsked: false, pending: null,
            shown: [], pageProduct: null, collections: null, nudged: false };
  var KEY = 'sew_bot_chat_v1';

  function toProduct(p) {
    return (window.SEWProduct && window.SEWProduct.toProduct) ? window.SEWProduct.toProduct(p) : null;
  }

  function norm(t) {
    return String(t).toLowerCase().replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function lev(a, b) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > 3) return 99;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur[0] = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      prev = cur.slice();
    }
    return prev[b.length];
  }
  function tol(w) { return w.length <= 4 ? 0 : (w.length <= 7 ? 1 : 2); }

  function detectLang(t) {
    if (/[\u0600-\u06FF]/.test(t)) return 'ur';
    var w = String(t).toLowerCase().replace(/[^a-z\s]/g, ' ').split(/\s+/).filter(Boolean);
    if (!w.length) return S.lang;
    var u = 0, e = 0;
    w.forEach(function (x) {
      if (UR.indexOf(x) > -1) u++;
      if (EN.indexOf(x) > -1) e++;
    });
    if (!u && !e) return S.lang;
    return u >= e ? 'ur' : 'en';
  }

  function T(ur, en) { return S.lang === 'ur' ? ur : en; }
  function money(n) { return CFG.cur + ' ' + Number(n).toLocaleString('en-PK'); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function waLink(m) { return 'https://wa.me/' + CFG.wa + '?text=' + encodeURIComponent(m); }

  function karachiNow() {
    var d = new Date();
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + CFG.tzOffset * 3600000);
  }
  function isOpenNow() {
    var k = karachiNow();
    if (k.getDay() === 0) return false;
    var h = k.getHours();
    return h >= CFG.openHour && h < CFG.closeHour;
  }

  function track(ev, data) {
    var row = { ts: new Date().toISOString(), ev: ev, lang: S.lang };
    for (var k in data) row[k] = data[k];
    try {
      var a = JSON.parse(localStorage.getItem('sew_bot_analytics') || '[]');
      a.push(row);
      localStorage.setItem('sew_bot_analytics', JSON.stringify(a.slice(-500)));
    } catch (e) {}
  }
  window.sewBotStats = function () {
    var a = [];
    try { a = JSON.parse(localStorage.getItem('sew_bot_analytics') || '[]'); } catch (e) {}
    var miss = a.filter(function (r) { return r.ev === 'miss'; });
    console.table(a);
    console.log('Un-answered questions (' + miss.length + '):', miss.map(function (r) { return r.q; }));
    return a;
  };

  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), lang: S.lang, msgs: S.msgs.slice(-40) }));
    } catch (e) {}
  }
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!d || Date.now() - d.t > 86400000) { localStorage.removeItem(KEY); return false; }
      S.msgs = d.msgs || [];
      S.lang = d.lang || 'en';
      return S.msgs.length > 0;
    } catch (e) { return false; }
  }

  function matchIntent(raw) {
    var text = norm(raw);
    var toks = text.split(' ').filter(Boolean);
    var best = null, bestScore = 0;
    KB.forEach(function (entry) {
      var score = 0;
      entry.k.forEach(function (kw) {
        if (kw.indexOf(' ') > -1) {
          if (text.indexOf(kw) > -1) score += 4;
          return;
        }
        for (var i = 0; i < toks.length; i++) if (toks[i] === kw) { score += 3; return; }
        for (var j = 0; j < toks.length; j++) if (lev(toks[j], kw) <= tol(kw)) { score += 1; return; }
      });
      if (score > bestScore) { bestScore = score; best = entry; }
    });
    return bestScore >= 3 ? best : null;
  }

  function isProductQuery(raw) {
    var text = norm(raw);
    var toks = text.split(' ').filter(Boolean);
    for (var i = 0; i < PT.length; i++) {
      var t = PT[i];
      if (t.indexOf(' ') > -1) { if (text.indexOf(t) > -1) return true; }
      else { for (var j = 0; j < toks.length; j++) if (toks[j] === t || lev(toks[j], t) <= tol(t)) return true; }
    }
    return false;
  }

  /* "is this available", "iski price kya hai" while standing on a product page */
  function refersToThisPage(raw) {
    if (!S.pageProduct) return false;
    var text = norm(raw);
    for (var i = 0; i < THIS_PHRASES.length; i++) {
      if (text.indexOf(THIS_PHRASES[i]) > -1) return true;
    }
    if (text.indexOf('this') > -1 || text.indexOf(' ye ') > -1 || text.indexOf(' yeh ') > -1) {
      for (var j = 0; j < ABOUT_WORDS.length; j++) {
        if (text.indexOf(ABOUT_WORDS[j]) > -1) return true;
      }
    }
    return false;
  }

  function budgetOf(raw) {
    var m = norm(raw).match(/(\d{3,6})/g);
    if (!m) return null;
    var nums = m.map(Number).filter(function (n) { return n >= 100 && n <= 500000; });
    if (!nums.length) return null;
    var t = norm(raw);
    var over = /(above|over|zyada|upar|se zyada|se upar|minimum|at least)/.test(t);
    if (nums.length >= 2) return { min: Math.min.apply(null, nums), max: Math.max.apply(null, nums) };
    if (over) return { min: nums[0], max: 9999999 };
    return { min: 0, max: nums[0] };
  }

  function getJSON(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function byHandles(handles) {
    return Promise.all(handles.slice(0, 6).map(function (h) {
      return getJSON('/products/' + h + '.js').then(toProduct).catch(function () { return null; });
    })).then(function (list) { return list.filter(Boolean); });
  }

  function browseAll(limit) {
    return getJSON('/products.json?limit=' + (limit || 16))
      .then(function (d) { return (d.products || []).map(toProduct).filter(Boolean); })
      .catch(function () { return []; });
  }

  function searchProducts(raw, cb) {
    var budget = budgetOf(raw);
    var terms = norm(raw).split(' ').filter(function (w) {
      return w.length > 2 && !/^\d+$/.test(w) &&
        FILLER.indexOf(w) === -1 && UR.indexOf(w) === -1 && EN.indexOf(w) === -1;
    });
    var q = terms.join(' ');

    function finish(list) {
      if (budget) {
        list = list.filter(function (p) { return p.price > 0 && p.price >= budget.min && p.price <= budget.max; });
        list.sort(function (a, b) { return b.price - a.price; });
      }
      cb(list.slice(0, 4), budget, terms);
    }

    if (!q) { browseAll(budget ? 250 : 16).then(finish); return; }

    getJSON('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
      .then(function (d) {
        var hits = (d.resources && d.resources.results && d.resources.results.products) || [];
        var handles = hits.map(function (h) { return h.handle; }).filter(Boolean);
        if (!handles.length) return [];
        return byHandles(handles);
      })
      .then(function (list) {
        if ((!list || !list.length) && budget) { browseAll(250).then(finish); return; }
        finish(list || []);
      })
      .catch(function () {
        if (budget) { browseAll(250).then(finish); return; }
        finish([]);
      });
  }

  function recommendFor(product, cb) {
    getJSON('/recommendations/products.json?product_id=' + product.id + '&limit=6&intent=related')
      .then(function (d) {
        var list = (d.products || []).map(toProduct).filter(function (p) {
          return p && p.available && S.shown.indexOf(p.id) === -1;
        });
        cb(list.slice(0, 2));
      })
      .catch(function () { cb([]); });
  }

  function loadCollections() {
    if (S.collections) return Promise.resolve(S.collections);
    return getJSON('/collections.json?limit=250')
      .then(function (d) {
        S.collections = (d.collections || []).map(function (c) {
          return { title: c.title, handle: c.handle };
        });
        return S.collections;
      })
      .catch(function () { S.collections = []; return S.collections; });
  }

  function matchCollection(terms, cb) {
    if (!terms || !terms.length) { cb(null); return; }
    loadCollections().then(function (cols) {
      var best = null, bestScore = 0;
      cols.forEach(function (c) {
        var title = String(c.title).toLowerCase();
        var words = title.split(/[^a-z0-9]+/).filter(Boolean);
        var score = 0;
        terms.forEach(function (t) {
          if (title.indexOf(t) > -1) { score += 2; return; }
          for (var i = 0; i < words.length; i++) {
            if (lev(words[i], t) <= tol(t)) { score += 1; return; }
          }
        });
        if (score > bestScore) { bestScore = score; best = c; }
      });
      cb(bestScore >= 2 ? best : null);
    });
  }

  function currentProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function loadPageProduct() {
    var h = currentProductHandle();
    if (!h) return;
    getJSON('/products/' + h + '.js')
      .then(function (p) { S.pageProduct = toProduct(p); })
      .catch(function () {});
  }

  function getCart(cb) {
    getJSON('/cart.js').then(cb).catch(function () { cb(null); });
  }

  var root = document.createElement('div');
  root.className = 'sewb';
  root.innerHTML =
    '<button class="sewb-fab" aria-label="Chat with ' + CFG.bot + '">' +
      '<span class="sewb-badge"></span>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>' +
      '<circle cx="12" cy="11.5" r="2.2"/></svg>' +
    '</button>' +
    '<div class="sewb-panel" role="dialog" aria-label="' + CFG.bot + '">' +
      '<div class="sewb-head">' +
        '<div class="sewb-av"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<rect x="4" y="8" width="16" height="11" rx="2.5"/><path d="M12 8V4.5"/><circle cx="12" cy="3.2" r="1.4"/>' +
        '<circle cx="9" cy="13" r="1"/><circle cx="15" cy="13" r="1"/></svg></div>' +
        '<div><div class="sewb-hname">' + CFG.bot + '</div>' +
        '<div class="sewb-hsub"><span class="sewb-dot"></span><span class="sewb-status">Online</span></div></div>' +
        '<button class="sewb-x" aria-label="Close"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      '</div>' +
      '<div class="sewb-body"></div>' +
      '<div class="sewb-foot">' +
        '<textarea class="sewb-in" rows="1" placeholder="Type your message..."></textarea>' +
        '<button class="sewb-send" aria-label="Send"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg></button>' +
      '</div>' +
      '<div class="sewb-cred">SEW MARKAZ &middot; ' + CFG.tagline + '</div>' +
    '</div>';
  document.body.appendChild(root);

  var fab = root.querySelector('.sewb-fab');
  var panel = root.querySelector('.sewb-panel');
  var body = root.querySelector('.sewb-body');
  var input = root.querySelector('.sewb-in');
  var sendBtn = root.querySelector('.sewb-send');
  var closeBtn = root.querySelector('.sewb-x');
  var badge = root.querySelector('.sewb-badge');
  var statusEl = root.querySelector('.sewb-status');

  function scroll() { body.scrollTop = body.scrollHeight; }

  function addMsg(who, text, persist) {
    var d = document.createElement('div');
    d.className = 'sewb-msg sewb-' + who;
    d.textContent = text;
    body.appendChild(d);
    scroll();
    if (persist !== false) { S.msgs.push({ w: who, t: text }); save(); }
  }

  /* Interface labels stay in English regardless of the chat language. */
  function addNote(text) {
    var d = document.createElement('div');
    d.className = 'sewb-note';
    d.textContent = text;
    body.appendChild(d);
    scroll();
  }

  function addChips(list) {
    if (!list || !list.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'sewb-chips';
    list.forEach(function (c) {
      var b = document.createElement('button');
      b.className = 'sewb-chip';
      b.textContent = c;
      b.onclick = function () { wrap.remove(); handle(c); };
      wrap.appendChild(b);
    });
    body.appendChild(wrap);
    scroll();
  }

  function addLink(label, href, ev) {
    var a = document.createElement('a');
    a.className = 'sewb-link';
    a.href = href;
    a.innerHTML = esc(label) + '<span>&rarr;</span>';
    a.onclick = function () { track(ev || 'link_click', { href: href }); };
    body.appendChild(a);
    scroll();
  }

  function addWA(prefill) {
    var a = document.createElement('a');
    a.className = 'sewb-wa';
    a.href = waLink(prefill);
    a.target = '_blank';
    a.rel = 'noopener';
    a.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM12 2C6.48 2 2 6.48 2 12c0 1.77.46 3.42 1.27 4.86L2 22l5.25-1.24A9.94 9.94 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/></svg>' + T('WhatsApp par baat karein', 'Continue on WhatsApp');
    a.onclick = function () { track('wa_click', {}); };
    body.appendChild(a);
    scroll();
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'sewb-toast';
    t.textContent = msg;
    root.appendChild(t);
    setTimeout(function () { t.remove(); }, 2400);
  }

  function addToCart(p, btn) {
    if (!p.variantId) { window.location.href = p.url; return; }
    btn.disabled = true;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = T('Shamil ho gaya', 'Added');
        toast(T('Cart mein shamil ho gaya', 'Added to cart'));
        track('cart_add', { product: p.title });
        S.nudged = false;
        showFreeDeliveryProgress(function (shown) {
          if (!shown) {
            addMsg('bot', T('Cart mein shamil kar diya gaya.', 'Added to your cart.'));
          }
          addChips(T(['Checkout karna hai', 'Aur products dekhne hain'], ['Go to checkout', 'Show me more']));
        });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = T('Cart mein daalein', 'Add to cart');
        toast(T('Shamil nahi ho saka, dobara koshish karein', 'Could not add. Please try again.'));
      });
  }

  /* Shows how close the cart is to free delivery, and what would close the gap. */
  function showFreeDeliveryProgress(done) {
    done = done || function () {};
    if (S.nudged) { done(false); return; }
    getCart(function (cart) {
      if (!cart || !cart.item_count) { done(false); return; }
      var total = Math.round(cart.total_price / 100);
      var gap = CFG.freeOver - total;
      S.nudged = true;

      if (gap <= 0) {
        addMsg('bot', T('Aap ke cart mein ' + money(total) + ' ka saman hai, to Karachi ke andar delivery free hai.',
                        'Your cart is at ' + money(total) + ', so delivery within Karachi is free.'));
        addLink(T('Checkout par jayein', 'Go to checkout'), '/cart', 'checkout_click');
        done(true);
        return;
      }

      var pct = Math.max(4, Math.min(100, Math.round(total / CFG.freeOver * 100)));
      var card = document.createElement('div');
      card.className = 'sewb-goal';
      card.innerHTML =
        '<b>' + esc(T(money(gap) + ' aur, phir delivery free', money(gap) + ' away from free delivery')) + '</b>' +
        '<div class="sewb-bar"><i style="width:' + pct + '%"></i></div>' +
        '<small>' + esc(T('Cart: ' + money(total) + ' \u00b7 Karachi ke andar Rs. 3,000 par free',
                          'Cart: ' + money(total) + ' \u00b7 free within Karachi at Rs. 3,000')) + '</small>';
      body.appendChild(card);
      scroll();
      track('free_delivery_nudge', { total: total, gap: gap });

      browseAll(250).then(function (all) {
        var fits = all.filter(function (p) {
          return p.available && p.price >= Math.max(150, Math.round(gap * 0.6)) && p.price <= Math.round(gap * 1.8);
        });
        fits.sort(function (a, b) { return Math.abs(a.price - gap) - Math.abs(b.price - gap); });
        if (fits.length) {
          addMsg('bot', T('Ye is faasle ke qareeb hain:', 'These would just about cover the gap:'));
          renderProducts(fits.slice(0, 2), false);
        }
        done(true);
      });
    });
  }

  function renderProducts(list, withRecs) {
    var wrap = document.createElement('div');
    wrap.className = 'sewb-prods';
    list.forEach(function (p) {
      if (S.shown.indexOf(p.id) === -1) S.shown.push(p.id);
      var card = document.createElement('div');
      card.className = 'sewb-card';
      var thumb;
      if (p.img) { thumb = document.createElement('img'); thumb.className = 'sewb-thumb'; thumb.src = p.img; thumb.alt = ''; }
      else { thumb = document.createElement('div'); thumb.className = 'sewb-thumb'; thumb.textContent = 'SEW'; }
      var info = document.createElement('div');
      info.className = 'sewb-pinfo';
      info.innerHTML = '<div class="sewb-ptitle">' + esc(p.title) + '</div><div class="sewb-pprice">' + money(p.price) + '</div>';
      var acts = document.createElement('div');
      acts.className = 'sewb-pact';
      var view = document.createElement('button');
      view.className = 'sewb-btn';
      view.textContent = T('Dekhein', 'View');
      view.onclick = function () { track('product_view', { product: p.title }); window.location.href = p.url; };
      acts.appendChild(view);
      if (p.available) {
        var cart = document.createElement('button');
        cart.className = 'sewb-btn solid';
        cart.textContent = T('Cart mein daalein', 'Add to cart');
        cart.onclick = function () { addToCart(p, cart); };
        acts.appendChild(cart);
      } else {
        var oos = document.createElement('span');
        oos.className = 'sewb-oos';
        oos.textContent = T('Stock mein nahi', 'Out of stock');
        acts.appendChild(oos);
      }
      info.appendChild(acts);
      card.appendChild(thumb);
      card.appendChild(info);
      wrap.appendChild(card);
    });
    body.appendChild(wrap);
    scroll();

    if (withRecs && list.length) {
      recommendFor(list[0], function (rel) {
        if (!rel.length) return;
        addMsg('bot', T('Customers aksar in ke sath ye bhi lete hain:', 'Customers often pair these together:'));
        renderProducts(rel, false);
      });
    }
  }

  function answerAboutPageProduct() {
    var p = S.pageProduct;
    track('hit', { q: p.title, intent: 'page_product' });
    S.fails = 0;
    addMsg('bot', p.available
      ? T(p.title + ' ki qeemat ' + money(p.price) + ' hai aur ye stock mein hai.',
          p.title + ' is ' + money(p.price) + ' and it is in stock.')
      : T(p.title + ' ki qeemat ' + money(p.price) + ' hai, lekin filhaal stock mein nahi.',
          p.title + ' is ' + money(p.price) + ', but it is out of stock at the moment.'));
    renderProducts([p], true);
  }

  function askLead(reason) {
    if (S.leadAsked) { addWA(T('Assalam o Alaikum, mujhe is baare mein madad chahiye: ', 'Hello, I need help with: ') + reason); return; }
    S.leadAsked = true;
    track('lead_form_shown', { reason: reason });
    addMsg('bot', T('Apna naam aur number chhod dein, hamari team WhatsApp par rabta kar legi.', 'Leave your name and number and our team will get back to you on WhatsApp.'));
    var f = document.createElement('div');
    f.className = 'sewb-lead';
    f.innerHTML =
      '<label>' + T('Aap ka naam', 'Your name') + '</label>' +
      '<input class="sewb-ln" type="text" placeholder="' + T('Naam', 'Name') + '">' +
      '<label>WhatsApp number</label>' +
      '<input class="sewb-lp" type="tel" inputmode="tel" placeholder="03XX XXXXXXX">' +
      '<div class="sewb-err" style="display:none"></div>';
    var btn = document.createElement('button');
    btn.className = 'sewb-btn solid';
    btn.style.cssText = 'padding:9px;font-size:12px';
    btn.textContent = T('Bhej dein', 'Submit');
    f.appendChild(btn);
    btn.onclick = function () {
      var n = f.querySelector('.sewb-ln').value.trim();
      var p = f.querySelector('.sewb-lp').value.replace(/\D/g, '');
      var err = f.querySelector('.sewb-err');
      if (n.length < 2) { err.textContent = T('Bara-e-meherbani naam likhein', 'Please enter your name'); err.style.display = 'block'; return; }
      if (p.length < 10) { err.textContent = T('Bara-e-meherbani sahih number likhein', 'Please enter a valid phone number'); err.style.display = 'block'; return; }
      track('lead_captured', { name: n, phone: p, reason: reason });
      f.remove();
      var soon = isOpenNow() ? T('jald', 'shortly') : T('agle working day', 'on the next working day');
      addMsg('bot', T('Shukriya ' + n + '. Hamari team ' + soon + ' aap se rabta karegi.', 'Thank you, ' + n + '. Our team will contact you ' + soon + '.'));
      addWA(T('Assalam o Alaikum, main ' + n + ' hoon (' + p + '). Mera sawal: ' + reason, 'Hello, this is ' + n + ' (' + p + '). My question: ' + reason));
    };
    body.appendChild(f);
    scroll();
  }

  function orderFlow(step, val) {
    if (step === 'start') {
      S.pending = 'order';
      addMsg('bot', T('Apna order number bata dein (misaal ke taur par #1234). Main aap ko team se connect kar deta hoon.', 'Please share your order number, for example #1234. I will connect you with our team.'));
      return;
    }
    S.pending = null;
    track('order_track', { order: val });
    addMsg('bot', T('Order ' + val + ' noted. Team status check kar ke aap ko bata degi. Neeche button par tap karein, message pehle se tayar hai.', 'Order ' + val + ' noted. Our team will check the status for you. Tap below, the message is already prepared.'));
    addWA(T('Assalam o Alaikum, mera order ' + val + ' hai. Bara-e-meherbani status bata dein.', 'Hello, my order number is ' + val + '. Could you share the current status?'));
  }

  function typing() {
    var d = document.createElement('div');
    d.className = 'sewb-msg sewb-bot sewb-typing';
    d.innerHTML = '<i></i><i></i><i></i>';
    body.appendChild(d);
    scroll();
    return d;
  }

  function handle(raw) {
    var text = String(raw).trim();
    if (!text) return;
    addMsg('user', text);
    S.lang = detectLang(text);
    input.placeholder = T('Message likhein...', 'Type your message...');
    var t = typing();

    setTimeout(function () {
      t.remove();

      if (S.pending === 'order') {
        var num = text.match(/#?\d{3,10}/);
        if (num) { orderFlow('got', num[0]); return; }
        S.pending = null;
      }

      if (/\b(order|track|tracking|parcel|shipment|courier|kahan hai|mera order)\b/i.test(norm(text))) {
        track('hit', { q: text, intent: 'order_track' });
        orderFlow('start');
        return;
      }

      var intent = matchIntent(text);
      var faqFirst = intent && ['shipping','delivery_time','cod','payment','return','damaged','refund_process','failed_delivery','cancel','care'].indexOf(intent.id) > -1;

      if (refersToThisPage(text) && !faqFirst) { answerAboutPageProduct(); return; }

      var wantsProducts = isProductQuery(text) || budgetOf(text) !== null;

      if (wantsProducts && !faqFirst) {
        track('hit', { q: text, intent: 'product_search' });
        S.fails = 0;
        searchProducts(text, function (list, budget, terms) {
          if (!list.length) {
            addMsg('bot', T(budget ? 'Is budget mein filhaal kuch nahi mila. Range thori barha kar dekhein?' : 'Is naam se kuch nahi mila. Doosre lafz istemal kar ke dekhein?',
              budget ? 'Nothing available in that range at the moment. Would you like to widen the budget?' : 'I could not find anything matching that. Try describing it differently.'));
            addChips(['Wall art', 'Bathroom', 'Kitchen', 'Car hangings']);
            return;
          }
          addMsg('bot', budget
            ? T(money(budget.max) + ' tak ye options hain:', 'Here is what fits under ' + money(budget.max) + ':')
            : T('Ye options hain:', 'Here is what I found:'));
          renderProducts(list, true);
          matchCollection(terms, function (col) {
            if (col) addLink(T('Saare ' + col.title + ' dekhein', 'Browse all ' + col.title), '/collections/' + col.handle, 'collection_click');
          });
        });
        return;
      }

      if (intent) {
        track('hit', { q: text, intent: intent.id });
        S.fails = 0;
        addMsg('bot', T(intent.ur, intent.en));
        if (intent.lead) { setTimeout(function () { askLead(text); }, 550); }
        else { addChips(T(intent.cu, intent.ce)); }
        return;
      }

      S.fails++;
      track('miss', { q: text, fails: S.fails });
      if (S.fails >= 2) {
        addMsg('bot', T('Main ye theek se samajh nahi paa raha. Behtar hoga ke aap seedha team se baat kar lein.', 'I am not able to answer that one. It is best to speak with our team directly.'));
        askLead(text);
      } else {
        addMsg('bot', T('Is baare mein mere paas maloomat nahi. Main in cheezon mein madad kar sakta hoon:', 'I do not have an answer for that. Here is what I can help with:'));
        addChips(T(
          ['Products dekhne hain', 'Delivery charges', 'COD aur payment', 'Return policy', 'Order track karna hai', 'Team se baat karni hai'],
          ['Browse products', 'Delivery charges', 'COD & payment', 'Return policy', 'Track my order', 'Talk to the team']));
      }
    }, 480 + Math.random() * 320);
  }

  function openPanel() {
    S.open = true;
    panel.classList.add('on');
    badge.style.display = 'none';
    track('open', {});

    if (!body.children.length) {
      if (load()) {
        S.msgs.forEach(function (m) { addMsg(m.w, m.t, false); });
        addNote('Earlier in this conversation');
        showFreeDeliveryProgress();
      } else {
        if (!isOpenNow()) addNote('Our team is offline right now. I can still help.');
        var g = KB[0];
        addMsg('bot', T(g.ur, g.en));

        if (S.pageProduct) {
          var p = S.pageProduct;
          addMsg('bot', T('Aap abhi ' + p.title + ' dekh rahe hain (' + money(p.price) + '). Is ke baare mein kuch poochna ho to bata dein.',
                          'You are looking at ' + p.title + ' (' + money(p.price) + '). Ask me anything about it.'));
          addChips(T(['Ye stock mein hai?', 'Delivery charges', 'Return policy'],
                     ['Is this in stock?', 'Delivery charges', 'Return policy']));
        } else {
          addChips(T(g.cu, g.ce));
        }
        showFreeDeliveryProgress();
      }
    }
    setTimeout(function () { input.focus(); scroll(); }, 260);
  }
  function closePanel() { S.open = false; panel.classList.remove('on'); }

  fab.onclick = function () { S.open ? closePanel() : openPanel(); };
  closeBtn.onclick = closePanel;
  sendBtn.onclick = function () {
    var v = input.value;
    input.value = '';
    input.style.height = 'auto';
    handle(v);
  };
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendBtn.click(); }
  });
  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 92) + 'px';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && S.open) closePanel();
  });

  if (!isOpenNow()) {
    statusEl.textContent = 'Mon to Sat, 10 AM to 8 PM';
    root.querySelector('.sewb-dot').classList.add('off');
  }

  loadPageProduct();
})();
